import { LLM_MODELS } from './models.js';
/**
 * Capability tiers, computed as a fraction of the highest intelligence score
 * currently in the registry. Tiers auto-adjust as new, stronger models raise
 * the ceiling — no manual reclassification needed.
 */
export var LlmModelIntelligenceTier;
(function (LlmModelIntelligenceTier) {
    LlmModelIntelligenceTier["Frontier"] = "frontier";
    LlmModelIntelligenceTier["Strong"] = "strong";
    LlmModelIntelligenceTier["Moderate"] = "moderate";
    LlmModelIntelligenceTier["Basic"] = "basic";
})(LlmModelIntelligenceTier || (LlmModelIntelligenceTier = {}));
const FRONTIER_RATIO = 0.85;
const STRONG_RATIO = 0.65;
const MODERATE_RATIO = 0.5;
/** Highest intelligence score across the registry — the tier ceiling. */
const MAX_INTELLIGENCE_SCORE = Math.max(0, ...Object.values(LLM_MODELS).map((model) => model.intelligenceScore ?? 0));
/** Buckets a raw intelligence score into a tier relative to the registry ceiling. */
export function getLlmIntelligenceTierForScore(score) {
    const ratio = MAX_INTELLIGENCE_SCORE > 0 ? score / MAX_INTELLIGENCE_SCORE : 0;
    if (ratio >= FRONTIER_RATIO) {
        return LlmModelIntelligenceTier.Frontier;
    }
    if (ratio >= STRONG_RATIO) {
        return LlmModelIntelligenceTier.Strong;
    }
    if (ratio >= MODERATE_RATIO) {
        return LlmModelIntelligenceTier.Moderate;
    }
    return LlmModelIntelligenceTier.Basic;
}
/** The model's tier, or `undefined` when it carries no intelligence score. */
export function getLlmModelIntelligenceTier(model) {
    if (model.intelligenceScore === undefined) {
        return undefined;
    }
    return getLlmIntelligenceTierForScore(model.intelligenceScore);
}
//# sourceMappingURL=intelligence.js.map